import { render, staticRenderFns } from "./FunctionReport.vue?vue&type=template&id=b3c4e9fa&scoped=true"
import script from "./FunctionReport.vue?vue&type=script&lang=js"
export * from "./FunctionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c4e9fa",
  null
  
)

export default component.exports